
const headers = [
    {
      label: 'ชื่อ - นามสกุล',
      field: 'fullname',
    },
    {
      label: 'ตำแหน่งงาน',
      field: 'position',
      tdClass: 'text-center',
    },
    {
      label: 'ตำแหน่งในอนุกรรมการ',
      field: 'directorPositionName',
      tdClass: 'text-center',
    },
    {
      label: 'สถานะการใช้งาน',
      field: 'isActive',      
    },
    // {
    //   label: 'แก้ไขข้อมูลล่าสุด',
    //   field: 'updateDate', 
    // },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers